import { Axios } from 'utils'
import { ItemResponseType, ListResponseType } from './types'
import { Permissions } from '../types/permissions'

export const usePermissionsService = () => {
  const getUserPermissions = async () => {
    try {
      const response = await Axios.post<ItemResponseType<Permissions>>(
        `/users/permissions/grouped`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getUserPermissions,
  }
}

export default usePermissionsService
